import { render, staticRenderFns } from "./parts-list.vue?vue&type=template&id=4f852062"
import script from "./parts-list.vue?vue&type=script&lang=js"
export * from "./parts-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports